









import { Component, Vue, Prop } from 'vue-property-decorator';

type ResponsePrivacyPolicy = { thirdParties: { [key: string]: string[] } };

@Component({
  components: {
    V2Ja: () => import('@/privacy_policy/v2/ja/Index.vue'),
    V2Vi: () => import('@/privacy_policy/v2/vi/Index.vue'),
    V2En: () => import('@/privacy_policy/v2/en/Index.vue'),
    V2Id: () => import('@/privacy_policy/v2/id/Index.vue')
  }
})
export default class Page extends Vue {
  private isLoadingComponent: boolean = true;
  private isLoadingThirdParties: boolean = true;
  private response: ResponsePrivacyPolicy | null = null;

  @Prop({ type: Number, required: true })
  public version!: number;

  @Prop({ type: String, required: true })
  public language!: string;

  private get orgs(): string[] {
    if (this.response === null) return [];
    return this.response.thirdParties[this.language] || [];
  }

  private async created(): Promise<void> {
    // 言語切り替え時にフラグを寝かせてロードする
    this.$watch(
      (): string => `${this.version}_${this.language}`,
      (): unknown => (this.isLoadingComponent = true)
    );

    // 全てのロードが完了したら親要素に伝える
    this.$watch(
      (): boolean => this.isLoadingComponent || this.isLoadingThirdParties,
      (value: boolean): unknown => this.$emit('isLoading', value)
    );

    let isSuccess: boolean = false;

    if (process.env.NODE_ENV === 'development') {
      const thirdParties: { [key: string]: string[] } = {};
      thirdParties['ja'] = ['a', 'b', 'c'];
      thirdParties['en'] = ['x', 'y', 'z'];
      this.response = { thirdParties };
      isSuccess = true;
    } else {
      try {
        const url = `${process.env.VUE_APP_API_ENDPOINT}/unauthorized/privacy_policy_third_parties`;
        const timeout = 30000;

        const responseRaw: Response = await Promise.race([
          window.fetch(url),
          new Promise<Response>((_, reject) => setTimeout(() => reject(new Error('request timeout')), timeout))
        ]);
        if (responseRaw.ok) {
          this.response = await responseRaw.json();
          isSuccess = true;
        }
      } catch (error) {}
    }

    if (isSuccess) {
      this.isLoadingThirdParties = false;
    }
    this.$emit('onPageLoaded', isSuccess);
  }
}
